/**
 * Helps knowing what business representative section needs to function
 */
export class BusinessRepresentativeLabels {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public name: string,
    public lastName: string,
    public email: string,
    public confirmEmail: string,
    public password: string,
    public confirmPassword: string,
    public inform: string,
    public emailInform: string,
    public and: string,
    public passwordInform: string,
    public inform2: string,
    public inform3: string,
    public middleHeader: string,
    public agree: string,
    public termsAndConditions: string,
    public privacy: string,
    public fileUpload: string[],
    public fileUploadAlt: string[]
  ) {}
}
